import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { CONSULT_URL } from '../config/constants';

const { FiMail, FiPhone, FiGlobe } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="wow-gradient-bg text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="flex items-center mb-6">
              <img src="https://wowdigital.com/logo_white.png" alt="Wow Digital Logo" className="max-w-[187.5px] h-auto mb-4" />
            </div>
            <p className="text-white/80 mb-6">
              Every day you wait is costing your nonprofit real money. The most successful organizations don't wait for "perfect timing"—they take action now.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="text-white/80" />
                <a href="mailto:info@wowdigital.com" className="hover:text-white/100 transition-colors">info@wowdigital.com</a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="text-white/80" />
                <span>1-888-238-9679</span>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiGlobe} className="text-white/80" />
                <a href="https://wowdigital.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/100 transition-colors">wowdigital.com</a>
              </div>
            </div>
          </div>
          <div className="text-center md:text-right">
            <a
              href={CONSULT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-gray-100 text-[#0066FF] font-semibold px-8 py-4 rounded-lg transition-colors text-lg inline-block"
            >
              Book Your Free Strategy Call
            </a>
            <p className="text-sm text-white/70 mt-4">
              No obligation • 30-minute consultation • Custom recommendations
            </p>
          </div>
        </div>
        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/70">
          <p>&copy;{currentYear} Wow Digital. Empowering nonprofits through exceptional web design.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;